import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

type WikiCardSkeletonProps = Readonly<{
  width?: number;
  className?: string;
}>;

const WikiCardSkeleton = ({ width, className }: WikiCardSkeletonProps) => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    // Caller width classes (e.g. w-[49%]) must sit on the outermost element,
    // and NativeWind doesn't style Animated.View — so the card is a plain
    // View and only the contents pulse. `flex: 1` + gap keep the author row
    // pinned to the bottom as before.
    <View
      style={width ? { width } : undefined}
      className={`bg-chalk rounded-xl p-2 ${className ?? ""}`}
    >
      <Animated.View style={{ opacity, flex: 1, gap: 8 }}>
        {/* Cover image */}
        <View className="h-32 w-full rounded-lg bg-ash-3" />

        {/* Title */}
        <View className="h-4 w-3/4 rounded-md bg-ash-3" />

        {/* Body lines */}
        <View className="gap-2">
          <View className="h-3 w-full rounded-md bg-ash-3" />
          <View className="h-3 w-5/6 rounded-md bg-ash-3" />
        </View>

        {/* Author row */}
        <View className="mt-auto pt-2 flex-row items-center gap-2">
          <View className="h-5 w-5 rounded-full bg-ash-3" />
          <View className="h-3 w-1/3 rounded-md bg-ash-3" />
        </View>
      </Animated.View>
    </View>
  );
};

export default WikiCardSkeleton;
